module.exports = __webpack_public_path__ + "static/media/epgdefaultchannelimage1.c0d92c21.png";